export default {
	GET_BANNER: "WebsiteSTNHD/TrangChu",
	GET_LESSON_CLIENT: "/MstLessonClient/listfilter",
	REGISTER_JOIN: "/MstRegisterTrail/Create",
	GET_UPLOAD_IMAGE: "/MstUploadimage/listFilter",

	HONOR_WEEK: "/MstHonorWeek/listFilter"
};
